var _mask, _path, _circle, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTreasure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3541 6C17.5363 6 16.8008 6.4979 16.4971 7.25722L15 11H8C3.58172 11 0 14.5817 0 19V33C0 37.4183 3.58172 41 8 41H40C44.4183 41 48 37.4183 48 33V19C48 14.5817 44.4183 11 40 11H33L31.5029 7.25722C31.1992 6.4979 30.4637 6 29.6459 6H18.3541Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4971 7.25722L19.2825 8.37139V8.37139L16.4971 7.25722ZM15 11V14H17.0311L17.7854 12.1142L15 11ZM33 11L30.2146 12.1142L30.9689 14H33V11ZM31.5029 7.25722L28.7175 8.37139V8.37139L31.5029 7.25722ZM19.2825 8.37139C19.1307 8.75105 18.763 9 18.3541 9V3C16.3095 3 14.471 4.24476 13.7117 6.14305L19.2825 8.37139ZM17.7854 12.1142L19.2825 8.37139L13.7117 6.14305L12.2146 9.88583L17.7854 12.1142ZM8 14H15V8H8V14ZM3 19C3 16.2386 5.23858 14 8 14V8C1.92487 8 -3 12.9249 -3 19H3ZM3 33V19H-3V33H3ZM8 38C5.23858 38 3 35.7614 3 33H-3C-3 39.0751 1.92487 44 8 44V38ZM40 38H8V44H40V38ZM45 33C45 35.7614 42.7614 38 40 38V44C46.0751 44 51 39.0751 51 33H45ZM45 19V33H51V19H45ZM40 14C42.7614 14 45 16.2386 45 19H51C51 12.9249 46.0751 8 40 8V14ZM33 14H40V8H33V14ZM28.7175 8.37139L30.2146 12.1142L35.7854 9.88583L34.2883 6.14305L28.7175 8.37139ZM29.6459 9C29.237 9 28.8693 8.75105 28.7175 8.37139L34.2883 6.14305C33.529 4.24475 31.6905 3 29.6459 3V9ZM18.3541 9H29.6459V3H18.3541V9Z",
    fill: "#152C5B",
    mask: "url(#path-1-inside-1)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 26,
    r: 6.5,
    stroke: "#FF498B",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 18L34 18",
    stroke: "#152C5B",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTreasure);
export default __webpack_public_path__ + "static/media/icon-treasure.557518ffb9858eadd3410516cd3a961f.svg";
export { ForwardRef as ReactComponent };